// extracted by mini-css-extract-plugin
module.exports = {"left":"matchup-page_left__S4YA0","right":"matchup-page_right__2fuI3"};